import { IconViewer } from '@vfmfe/foundations';
import {
    CardSelectorContainer,
    CardSelectorContent,
    CardSelectorTitle,
    CardSelectorDescription,
    CardSelectorButtonsRow,
    CardSelectorButtonContainer,
    CardSelectorButtonTitle
} from './CardSelector.styles';
import { CardSelectorProps } from './CardSelector.types';

export default function CardSelector({ items, title, description, onSelect }: CardSelectorProps) {
    return (
        <CardSelectorContainer>
            <CardSelectorContent>
                {title && <CardSelectorTitle>{title}</CardSelectorTitle>}
                {description && <CardSelectorDescription>{description}</CardSelectorDescription>}
                <CardSelectorButtonsRow>
                    {items.map((item) => (
                        <CardSelectorButtonContainer key={item.id} onClick={() => onSelect(item.id)}>
                            <IconViewer name={item.icon || 'apps'} size={5} />
                            <CardSelectorButtonTitle>{item.label}</CardSelectorButtonTitle>
                        </CardSelectorButtonContainer>
                    ))}
                </CardSelectorButtonsRow>
            </CardSelectorContent>
        </CardSelectorContainer>
    );
}
